import { Data2 } from "../../../../../features/data-types"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { useCustomerTypeActions } from "../../../actions/customerTypeActions"
import { useCustomerTypeBuilders } from "../../../builders/customerTypeBuilders"
import { ProductYield } from "../../../state/types"

export const useActions = () => {
    const { buildCustomerType } = useCustomerTypeBuilders()

    const { saveCustomerType } = useCustomerTypeActions()

    const submitCustomerType = async (
        data: Data2,
        customerTypeYield: number,
        productYields: ProductYield[],
        createMode: boolean
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const customerTypeData = {
            ...data,
            yield: customerTypeYield,
            productYields
        }
        const customerType = buildCustomerType(customerTypeData)
        
        await saveCustomerType(customerType)
        Emitter.emit(Event.DB_SUBMIT_DONE, createMode)
    }
    
    return {
        submitCustomerType
    }
}
